export default __webpack_public_path__ + "static/media/Venturer's Belt of the Savage Sun.6f34493b.jpg";